import React from 'react';

import Image from 'next/image';

import CustomIcon from '@components/utils/CustomIcon';
import { ReviewTripTypeViewModel, SubratingViewModel } from '@api/v3';
import palette from '@utils/theme/palette';
import Typography from '@components/Typography';

import { getRating, getReviewIcon } from './getReviewIcon';
import {
  Center,
  TotalScoringWrapper,
  ScoringContainer,
  Scoring,
  ScoringLine,
  TooltipContainer,
  TooltipTitle,
  Wrapper,
  Text,
  SpeacialHotelWrapper,
  VerticalLine,
  ReviewContainer,
  PercentContainer,
  PercentWrapper,
} from './scoringStyle';

export type DesktopScoringProps = {
  totalScoring?: number;
  subratings?: SubratingViewModel[];
  tripTypes?: ReviewTripTypeViewModel[];
};

const DesktopHotelDetailScoring = ({
  subratings,
  totalScoring,
  tripTypes,
}: DesktopScoringProps) => {
  return (
    <Wrapper>
      <TotalScoringWrapper>
        <ScoringContainer>
          <Center>
            <Typography
              variant='Title4'
              color='NL800'
              style={{ marginTop: '15px' }}
            >
              Genel Puan
            </Typography>

            <Scoring>
              <strong>{totalScoring}</strong>
            </Scoring>
            <Text>{getRating(totalScoring ?? 0)}</Text>
          </Center>
        </ScoringContainer>
      </TotalScoringWrapper>
      <SpeacialHotelWrapper>
        {subratings?.map((item) => (
          <TooltipContainer key={item?.key}>
            <TooltipTitle>
              <span>{item?.localizedName} </span>
            </TooltipTitle>
            <ScoringLine>
              <Image
                src={item?.image || ''}
                alt='playstoreqr'
                width={60}
                height={20}
              />
            </ScoringLine>
            <PercentWrapper>
              <Typography variant='Title5' style={{ paddingLeft: '40px' }}>
                {item?.value}/5
              </Typography>
            </PercentWrapper>
          </TooltipContainer>
        ))}
      </SpeacialHotelWrapper>
      <VerticalLine />
      <SpeacialHotelWrapper>
        {tripTypes?.map((item) => (
          <ReviewContainer key={item?.key}>
            <ScoringLine>
              <CustomIcon
                icon={getReviewIcon(item?.key || '')}
                fontSize={18}
                fill={palette.black}
              />
            </ScoringLine>
            <TooltipTitle>
              <span>{item?.localizedName} </span>
            </TooltipTitle>
            <PercentContainer>
              <Typography variant='caption'>{item?.value}</Typography>
            </PercentContainer>
          </ReviewContainer>
        ))}
      </SpeacialHotelWrapper>
    </Wrapper>
  );
};
export default DesktopHotelDetailScoring;
